import React from 'react';

function DataAnalysis() {
  return (
    <div>
      <h1>Home</h1>
      {/* Placeholder for Data Analysis content */}
    </div>
  );
}

export default DataAnalysis;
